/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { VideoEditorGetCompositionsByIdQueryResponse, VideoEditorGetCompositionsByIdPathParams, VideoEditorGetCompositionsByIdQueryParams, VideoEditorGetCompositionsById401, VideoEditorGetCompositionsById403 } from "../models/VideoEditorGetCompositionsById";

export function getVideoEditorGetCompositionsByIdUrl(id: VideoEditorGetCompositionsByIdPathParams["id"]) {
  const res = { method: 'GET', url: `/video-editor/v1/compositions/${id}` as const }
  return res
}

/**
 * @summary Retrieve a single Composition
 * {@link /video-editor/v1/compositions/:id}
 */
export async function videoEditorGetCompositionsById(id: VideoEditorGetCompositionsByIdPathParams["id"], params?: VideoEditorGetCompositionsByIdQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<VideoEditorGetCompositionsByIdQueryResponse, ResponseErrorConfig<VideoEditorGetCompositionsById401 | VideoEditorGetCompositionsById403>, unknown>({ method : "GET", url : getVideoEditorGetCompositionsByIdUrl(id).url.toString(), params, ... requestConfig })
  return res.data
}